import { useSelector } from "react-redux";
import { RootState } from "../store";
import { getRequestedRFZORequests } from "../utils/receivableItemUtils";
import { useTabNotifications } from "../hooks/useTabNotifications";

const TabNotificationManager = () => {
  const receivedOrders = useSelector(
    (state: RootState) => state.order.receivedOrders,
  );
  const rfzoTherapyRequests = useSelector(
    (state: RootState) => state.rfzoTherapy.rfzoTherapyRequests,
  );
  // An incoming consult only rings while nothing is on the call yet; once the
  // pharmacist joins, the PiP panel owns the call and the tab is back to
  // showing the order queue.
  const incomingConsultCount = useSelector(
    (state: RootState) => state.videoConsult.incomingConsults.length,
  );
  const activeConsult = useSelector(
    (state: RootState) => state.videoConsult.activeConsult,
  );

  const count =
    receivedOrders.length +
    getRequestedRFZORequests(rfzoTherapyRequests).length;

  useTabNotifications(count, incomingConsultCount > 0 && !activeConsult);

  return null;
};

export default TabNotificationManager;
